import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import {
    ActivationRequest,
    ActivationVerification,
    AuthRequest,
    AuthSession,
    PasscodeReference,
    PasscodeRequest,
    PasswordResetLinkRequest,
    PasswordResetRequest,
    PasswordResetVerification
} from "../models/auth.model";
import { buildHttpParams } from "../utils/http-params";

@Injectable({ providedIn: 'root' })
export class AuthEndpoint {
    private readonly http = inject(HttpClient);

    private readonly endpoints = {
        passwordReset: 'pub/password-reset',
        passwordResetSendLink: 'pub/password-reset/send-link',
        auth: 'pub/auth',
        authRequestPasscode: 'pub/auth/request-passcode',
        activation: 'pub/activation',
        passwordResetVerify: 'pub/password-reset/verify',
        activationVerify: 'pub/activation/verify'
    };

    resetPassword(body: PasswordResetRequest): Observable<void> {
        return this.http.post<void>(this.endpoints.passwordReset, body);
    }

    sendPasswordResetLink(body: PasswordResetLinkRequest): Observable<void> {
        return this.http.post<void>(this.endpoints.passwordResetSendLink, body);
    }

    authenticate(body: AuthRequest): Observable<AuthSession> {
        return this.http.post<AuthSession>(this.endpoints.auth, body);
    }

    requestPasscode(body: PasscodeRequest): Observable<PasscodeReference> {
        return this.http.post<PasscodeReference>(this.endpoints.authRequestPasscode, body);
    }

    activateAccount(body: ActivationRequest): Observable<void> {
        return this.http.post<void>(this.endpoints.activation, body);
    }

    verifyPasswordResetLink(link: string): Observable<PasswordResetVerification> {
        return this.http.get<PasswordResetVerification>(this.endpoints.passwordResetVerify, {
            params: buildHttpParams({ l: link })
        });
    }

    verifyActivationLink(link: string): Observable<ActivationVerification> {
        return this.http.get<ActivationVerification>(this.endpoints.activationVerify, {
            params: buildHttpParams({ l: link })
        });
    }
}
